import {praseIconfont} from '../utils/util'
import Svg2Icon from '@/components/Svg2Icon'
function appConfig(app){
  app.config.globalProperties.$iconfont = praseIconfont;

  app.component('Svg2Icon', Svg2Icon)
}


export default appConfig;